export default "__VITE_ASSET__BNp$sg4r__";